import { isRenderedAsIframeInNewUI } from 'config';
import { useEffect } from 'react';

export const useIframeDisableClicks = () => {
  useEffect(() => {
    if (!isRenderedAsIframeInNewUI) return;
    const disableRightClick = (event: MouseEvent) => {
      event.preventDefault();
    };

    const disableMiddleClick = (event: MouseEvent) => {
      if (event.button === 1) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    document.addEventListener('contextmenu', disableRightClick);
    document.addEventListener('mousedown', disableMiddleClick);
    document.addEventListener('auxclick', disableMiddleClick);

    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('mousedown', disableMiddleClick);
      document.removeEventListener('auxclick', disableMiddleClick);
    };
  }, []);
};
